export const ErrorCodesEnum = {
  INVALID_PHOTO_FORMAT: 'INVALID_PHOTO_FORMAT',
  IS_ALREADY_TAKEN: 'IS_ALREADY_TAKEN',
  NOT_FOUND: 'NOT_FOUND',
  FORBIDDEN: 'FORBIDDEN',
  UNAUTHORIZED: 'UNAUTHORIZED',
  ALREADY_AUTHORIZED: 'ALREADY_AUTHORIZED',
  REDIRECT: 'REDIRECT',
  INTERNAL_SERVER: 'INTERNAL_SERVER',
  BAD_REQUEST: 'BAD_REQUEST',
  TIME_LIMIT: 'TIME_LIMIT',
  LIMIT_EXCEEDED: 'LIMIT_EXCEEDED',
  INCORRECT_CODE: 'INCORRECT_CODE',
  INCORRECT_FLOW: 'INCORRECT_FLOW',
  EMAIL_ALREADY_USED: 'EMAIL_ALREADY_USED',
  UNCONFIRMED_EMAIL: 'UNCONFIRMED_EMAIL',
} as const;
